if(!customElements.get('ritual-stock-count')){customElements.define('ritual-stock-count',class extends HTMLElement {connectedCallback(){this.renderStockCount()}
  renderStockCount(){
    const node=this.querySelector('[data-rcp-stock-count]');
    if(!node||node.dataset.stockMode!=='session_random')return;
    const configuredMin=Math.max(1,Math.min(30,Number(node.dataset.stockMin)||3));
    const configuredMax=Math.max(1,Math.min(30,Number(node.dataset.stockMax)||7));
    const min=Math.min(configuredMin,configuredMax);
    const max=Math.max(configuredMin,configuredMax);
    const key=`ritual-stock:${this.dataset.productId||'product'}:${min}-${max}`;
    let count;
    try{count=Number(sessionStorage.getItem(key))}catch(_){}
    if(!Number.isInteger(count)||count<min||count>max){
      const random=new Uint32Array(1);
      if(globalThis.crypto?.getRandomValues)globalThis.crypto.getRandomValues(random);
      else random[0]=Math.floor(Math.random()*4294967296);
      count=min+random[0]%(max-min+1);
      try{sessionStorage.setItem(key,String(count))}catch(_){}
    }
    node.textContent=String(count);
  }

});}
